// src/components/renderers/OrderRenderer.js
import React from 'react';

const OrderRenderer = ({ 
  question, 
  userAnswer = [], 
  onAnswerChange, 
  showFeedback,
  showCorrectAnswers 
}) => {
  const content = question.content || {};
  const items = content.items || [];
  const instructions = content.instructions || '';

  // Initialize user answer if empty
  React.useEffect(() => {
    if (userAnswer.length === 0 && items.length > 0 && onAnswerChange) {
      // Start with items in their original order (shuffled)
      onAnswerChange(items.map(item => item.id));
    }
  }, []);

  const handleMoveUp = (index) => {
    if (index === 0 || !onAnswerChange || showFeedback) return;
    
    const newOrder = [...userAnswer];
    [newOrder[index], newOrder[index - 1]] = [newOrder[index - 1], newOrder[index]];
    onAnswerChange(newOrder);
  };

  const handleMoveDown = (index) => {
    if (index === userAnswer.length - 1 || !onAnswerChange || showFeedback) return;
    
    const newOrder = [...userAnswer];
    [newOrder[index], newOrder[index + 1]] = [newOrder[index + 1], newOrder[index]];
    onAnswerChange(newOrder);
  };

  const getItemText = (itemId) => {
    return items.find(item => item.id === itemId)?.text || '';
  };

  const getCorrectPosition = (itemId) => {
    return items.find(item => item.id === itemId)?.correctPosition || 0;
  };

  const isItemInCorrectPosition = (itemId, currentIndex) => {
    const correctPos = getCorrectPosition(itemId);
    return correctPos === currentIndex + 1;
  };

  return (
    <div className="question-renderer order-renderer">
      <div 
        className="question-instructions" 
        dangerouslySetInnerHTML={{ __html: instructions }} 
      />

      <div className="order-items-container">
        {userAnswer.map((itemId, index) => {
          const isCorrect = (showFeedback || showCorrectAnswers) && 
                           isItemInCorrectPosition(itemId, index);
          
          return (
            <div 
              key={itemId} 
              className={`order-item ${
                (showFeedback || showCorrectAnswers)
                  ? (isCorrect ? 'correct-position' : 'incorrect-position')
                  : ''
              }`}
            >
              <div className="item-position">{index + 1}</div>
              <div className="item-text">{getItemText(itemId)}</div>
              
              {!showFeedback && (
                <div className="item-controls">
                  <button
                    onClick={() => handleMoveUp(index)}
                    disabled={index === 0}
                    className="move-btn"
                  >
                    ↑
                  </button>
                  <button
                    onClick={() => handleMoveDown(index)}
                    disabled={index === userAnswer.length - 1}
                    className="move-btn"
                  >
                    ↓
                  </button>
                </div>
              )}
              
              {(showFeedback || showCorrectAnswers) && !isCorrect && (
                <div className="correct-position-indicator">
                  Should be: {getCorrectPosition(itemId)}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {showFeedback && content.generalFeedback && (
        <div className="feedback-section">
          <div className="general-feedback">
            <strong>Feedback:</strong> {content.generalFeedback}
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderRenderer;